// Customer identity + event keys. Pure — no Firebase.
import { normalizeMobile } from '../../shared/utils/formatters';

// Canonical customer key: last-10-digit mobile, sanitized for Firebase paths.
// MUST match the key used by the CSV import path so order-sync and import agree.
export const customerKey = (mobile) => {
    const n = normalizeMobile(mobile);
    return n ? n.replace(/[.#$[\]/]/g, '_') : '';
};

// Resolve which key to use for a given identity, in priority order:
// 1) primary mobile  2) secondary mobile  3) existing customerId
export const resolveCustomerKey = ({ mobile, secondaryMobile, customerId } = {}, knownKeys = new Set()) => {
    const primary = customerKey(mobile);
    if (primary && (knownKeys.size === 0 || knownKeys.has(primary))) return primary;
    const secondary = customerKey(secondaryMobile);
    if (secondary && knownKeys.has(secondary)) return secondary;
    if (customerId && knownKeys.has(customerId)) return customerId;
    return primary || secondary || customerId || '';
};

// Order lifecycle events that drive customer updates (Phase 3).
export const ORDER_EVENTS = {
    CREATED: 'created', PAID: 'paid', COD_CONFIRMED: 'cod_confirmed', PACKED: 'packed',
    SHIPPED: 'shipped', DELIVERED: 'delivered', CANCELLED: 'cancelled',
    RETURNED: 'returned', REFUNDED: 'refunded', REPLACEMENT: 'replacement', RESHIP: 'reship',
};

// Map a raw order.status string to a normalized lifecycle event.
export const normalizeOrderStatus = (status) => {
    const s = String(status || '').toLowerCase();
    if (/cancel/.test(s)) return ORDER_EVENTS.CANCELLED;
    if (/return|rto/.test(s)) return ORDER_EVENTS.RETURNED;
    if (/refund/.test(s)) return ORDER_EVENTS.REFUNDED;
    if (/deliver/.test(s)) return ORDER_EVENTS.DELIVERED;
    if (/ship|dispatch/.test(s)) return ORDER_EVENTS.SHIPPED;
    if (/pack/.test(s)) return ORDER_EVENTS.PACKED;
    if (/paid|processed|prepaid/.test(s)) return ORDER_EVENTS.PAID;
    return ORDER_EVENTS.CREATED;
};
